import { now } from "lodash";

const epoch = () => Math.floor(now() / 1000);

interface FordStandardError<T> {
  type: string;
  title: string;
  status?: string | number;
  messages?: string[];
  attributes: {
    timestamp: number;
  };
  originalResponse?: T;
  customErrorCode?: string;
}

interface CreateFordStandardErrorProps<T> {
  message?: string;
  originalResponse?: T;
  status?: number | string;
  customErrorCode?: string;
}

const createFordStandardError = <T>(
  args?: CreateFordStandardErrorProps<T>,
): FordStandardError<T> => {
  const { message, originalResponse, status, customErrorCode } = args ?? {};
  return {
    type: "https://apiguide.ford.com/metadata/ford-standard-error",
    title: "This error is detailed using Ford's standard error format.",
    status,
    messages: message ? [message] : undefined,
    attributes: {
      timestamp: epoch(),
    },
    originalResponse,
    customErrorCode,
  };
};

export { createFordStandardError };
export type { CreateFordStandardErrorProps, FordStandardError };
